import Menu from '../../components/Menu/Menu';
import useAuth from '../../hooks/useAuth';
import './Misc.scss';

// const Misc = ({ title, options }) => {
const Misc = () => {
    return (
        <div id='misc'>
            <div className='centered-container'>
                <Menu title="Misc" options={[
                    { name: 'Ev Cars', path: '/misc/evcars' },
                    { name: 'Minigames', path: '/misc/minigames' },
                    { name: 'Bingo Challenges', path: '/bingo/challenges', visible: ({ user }) => user?.roles?.includes('developer') },
                    { name: 'Git', path: '/git', visible: ({ user }) => user?.roles?.includes('git') },
                    { name: 'IA', path: '/ia', visible: ({ user }) => user?.roles?.includes('developer') },
                    { name: 'Año Nuevo', path: '/preguntas', visible: ({ user }) => user?.tag === 'newyear' },
                    { name: 'Metrics', path: '/metrics', visible: ({ user }) => user?.roles?.includes('developer') },
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
};

export default Misc;